import { v4 } from "uuid";
import less from "../static/icons/less.svg";
import lessEqual from "../static/icons/less-equal.svg";
import moreEqual from "../static/icons/more-equal.svg";
import equal from "../static/icons/equal.svg";
import more from "../static/icons/more.svg";


export const fields = [
  {
    id: "inputname",
    type: "text",
    label: "Name",
    placeholder: "Name",
    name: "name",
    key: v4(),
  },
  {
    id: "email",
    type: "email",
    label: "Email",
    placeholder: "Email",
    name: "email",
    key: v4(),
  },
  {
    id: "phone",
    type: "tel",
    label: "Phone",
    placeholder: "Phone",
    name: "phone",
    key: v4(),
  },
  {
    id: "company",
    type: "text",
    label: "Company",
    placeholder: "Company",
    name: "company",
    key: v4(),
  },
  {
    id: "role",
    type: "text",
    label: "Role",
    placeholder: "Role",
    name: "role",
    key: v4(),
  },
];

export const moreData = [
  {
    label: "Equal",
    value: 0,
    id: v4(),
    icon: equal,
  },
  {
    label: "More",
    value: 2,
    id: v4(),
    icon: more,
  },
  {
    label: "Less",
    value: 3,
    id: v4(),
    icon: less,
  },
  {
    label: "More or equal",
    value: 4,
    id: v4(),
    icon: moreEqual,
  },
  {
    label: "Less or equal",
    value: 5,
    id: v4(),
    icon: lessEqual,
  },
];

export const colors = [
  {
    name: "Blue",
    hex: "#4F80FF"
  },
  {
    name: "Red",
    hex: "#FF3C3C"
  },
  {
    name: "Green",
    hex: "#3EE93E"
  },
  {
    name: "Magenta",
    hex: "#FF4FFF"
  },
  {
    name: "Cyan",
    hex: "#4FFFFF"
  },
  {
    name: "Orange",
    hex: "#FF6600"
  },
  {
    name: "Pink",
    hex: "#FF99CC"
  },
  {
    name: "Brown",
    hex: "#993300"
  },
  {
    name: "Lavender",
    hex: "#9999FF"
  },
  {
    name: "Yellow",
    hex: "#FFFF4F"
  }];

export const tabType = {
  unsaved: "unsaved",
  saved: "saved",
  report: "report"
}

export const subscriptionType = {
  blocked: -1,
  trial: 0,
  basic: 1,
  premium: 2,
}